import ApiLogin from '@/services/ApiLogin'

class ClientLoginService {
  findById (id) {
    return ApiLogin().get(`senior/client/${id || ''}`)
  }
}

export default new ClientLoginService()
